
<div class="multiroom">
  <el-row class="multiroom-container" :gutter="0">
    <multi-room-stat />
    <draggable @end="sortTab" v-bind="dragOptions">
      <mini-room v-for="room in orderedRoom" :key="room.name" :id="room.id" :room="room" />
    </draggable>
  </el-row>
</div>
